import { onUnmounted } from 'vue'

export function useHelpBody () {
  document.body.classList.add('cm-help-body')

  onUnmounted(() => {
    document.body.classList.remove('cm-help-body')
  })
}
